module.exports = __webpack_public_path__ + "img/car_shina2_01.be124ee1.jpg";